import { HTMLMotionProps, motion } from "framer-motion";
import React from "react";
import { twMerge } from "tailwind-merge";

export type ButtonVariants =
  | "primary"
  | "secondary"
  | "rounded"
  | "carousel"
  | "primaryReversed"
  | "border"
  | "transparent"
  | "borderWhite"
  | "secondaryReversed";

export interface ButtonProps extends HTMLMotionProps<"button"> {
  key?: string | number;
  variant?: ButtonVariants;
}

const Button: React.FunctionComponent<ButtonProps> = ({
  variant = "primary",
  className = "",
  children,
  ...rest
}) => {
  const variantClassMap: Record<ButtonVariants, string> = {
    primary:
      "bg-primary-orange-50 text-white px-10 py-3 xl:py-[20px] rounded-[32px] md:h-[55px] text-[10px] md:text-sm font-semibold md:leading-normal",
    secondary:
      "bg-white text-dark-purple-50 px-10 py-3 xl:py-[20px] rounded-[32px] md:h-[55px] text-[10px] md:text-sm font-semibold md:leading-normal hover:bg-dark-purple-50 hover:text-white border-2 border-dark-purple-50",
    rounded: "rounded-full",
    carousel:
      " text-white fill-white rounded-full xl:h-12 xl:w-12 h-8 w-8 flex items-center justify-center disabled:bg-grey-80 disabled:pointer-events-none disabled:cursor-not-allowed bg-primary-blue-50",
    primaryReversed:
      "bg-dark-purple-50 text-white px-10 py-3 xl:py-[20px] rounded-[32px] md:h-[55px] text-[10px] md:text-sm font-semibold md:leading-normal hover:bg-primary-orange-50",
    border:
      "border-2 border-dark-purple-50 text-dark-purple-50 rounded-[32px] border border-black px-8 py-3 text-[10px] md:text-sm font-semibold",
    borderWhite:
      "border-2 border-white text-white rounded-[32px] px-8 py-[18] text-sm h-[55px] !text-sm font-semibold",
    transparent: "bg-transparent border-none flex items-center justify-center",
    secondaryReversed:
      "bg-dark-purple-50 text-white border-2 border-white px-10 py-3 xl:py-[20px] rounded-[32px] md:h-[55px] text-[10px] md:text-sm font-semibold md:leading-normal hover:bg-white hover:text-dark-purple-50",
  };
  const variantClass = variantClassMap[variant];
  return (
    <motion.button
      className={twMerge(
        "flex items-center justify-center transition-colors duration-200",
        variantClass,
        className
      )}
      whileTap={{ scale: 0.9 }}
      whileHover={{ scale: 1.02 }}
      {...rest}
    >
      {children}
    </motion.button>
  );
};

export default Button;
